import { Listbox } from '@headlessui/react';
import styled, { css } from 'styled-components';
import { getAppThemeName } from '../../../services/appTheme';
import { color } from '../../templates/Ui';
export const StyledListboxContainer = styled.div `
    position: relative;
    width: 184px;
    min-height: 30px;
`;
export const StyledListboxButton = styled(Listbox.Button) `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 15px 37px 15px 15px;
    white-space: nowrap;
    background-color: #fff;
    border-radius: 6px;
    border-width: 1px;
    border-style: solid;
    border-color: ${color.border.input};
    width: 100%;
    outline: none;
    border-radius: 0.25rem;

    ${() => getAppThemeName() === 'inkassier' &&
    css `
            &:not([value='']),
            &[data-headlessui-state='open'] {
                border-color: ${props => props.theme.secondary};

                ~ .focus-border {
                    width: 100%;
                }
            }
        `};
`;
export const StyledListboxButtonText = styled.span `
    width: 100%;
    min-height: 20px;
    color: #444;
    font-size: 15px;
    font-weight: 400;
    opacity: 1;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const StyledListboxButtonPlaceholder = styled.span `
    width: 100%;
    min-height: 20px;
    font-size: 15px;
    opacity: 1;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #29305740;
    font-weight: 400;
`;
export const StyledListboxOption = styled(Listbox.Option) `
    list-style: none;
    background-color: ${props => props.selected ? props.theme.primary.base : '#fff'};
    color: ${props => (props.selected ? '#fff' : props.theme.primary.base)};
    padding: 8px 12px;
    font-size: 0.75rem;
    cursor: pointer;
    &:not([aria-selected='true']):hover,
    &[data-headlessui-state='active'] {
        background-color: #deebff;
        color: #000;
    }
`;
export const StyledListboxOptions = styled(Listbox.Options) `
    position: absolute;
    width: 100%;
    z-index: 10;
    margin-top: 2px;
    background-color: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    box-shadow: 0 0 0 1px hsl(0deg 0% 0% / 10%),
        0 4px 11px hsl(0deg 0% 0% / 10%);
`;
export const StyledListboxIconWrapper = styled.div `
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 0;
    width: 32px;
    height: 100%;
    border-left: 1px solid ${color.border.input};
`;
export const StyledListboxLabel = styled(Listbox.Label) `
    display: block;
    color: ${props => props.theme.primary.base};
    font-size: 15px;
    font-weight: ${props => (props.activeFilter ? '700' : '400')};
    margin-bottom: 6px;
`;
